import { defaultRedirect } from '@/router'
import { isAuthenticated } from '@/services/auth'
import store from '@/store'
import permissionsHandler from '@/utils/permissionsHandler'

const defaultAuthRedirect = { name: 'page-sign-in' }

export const beforeEach = (to, from, next) => {
  const { auth, permissionKey } = to.meta
  if (!auth) return next() // public route

  const authRequired = auth === true || auth.required === true || false
  if (!authRequired) return next() // public route

  const redirect = () => {
    if (typeof auth.redirect === 'function') return auth.redirect({ from, to })
    const fromRoute = from.name ? from : null
    return auth.redirect || fromRoute || defaultAuthRedirect
  }

  if (!isAuthenticated()) {
    const route = redirect()
    // add a hint where to redirect after login (a query param)
    const redirectAfterLoginTo = to && to.fullPath
    if (redirectAfterLoginTo) {
      route.query = {
        ...route.query,
        redirect: redirectAfterLoginTo
      }
    }
    return next(route)
  }

  if (permissionKey !== undefined) {
    if (store.state.app.me) {
      const permissionsListKeys = store.state.app.me.permissions.map(p => p.key)
      // permissions guard
      // TODO: HARDCODE for 'READ'
      const fullPermissionKey = `READ_${permissionKey}`
      if (!permissionsHandler(permissionsListKeys, [fullPermissionKey])) {
        next({ name: defaultRedirect() })
      }
    }
  }

  // otherwise move forward
  next()
}

export const redirectIfAuthenticated = (to, from, next) => {
  if (!isAuthenticated()) return next()
  next({ name: defaultRedirect() })
}
